const ComponentBase = require('../../base/ComponentBase');
const CommonUtil = require('../../utils/CommonUtil');
/**
 * @constructor
 * @classdesc 截屏
 * @augments G.base.ComponentBase
 * @alias G.common.ScreenShot
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @example
 * //使用示例代码
 *         var screenShot = new G.common.ScreenShot({
 *             map:demo.emap
 *         });
 *         screenShot.downloadImage();
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
    },

    /**
     * 截图、获取图片
     * @method
     * @memberOf G.common.ScreenShot.prototype
     * @param [domId] {String} 截图的dom id
     * @returns {String}
     * 
     */
    getImage(domId) {
        return new Promise((resolve, reject) => {
            var element = document.getElementById(domId || this.map.options.targetId);
            html2canvas(element, { //
                onrendered: function(canvas) {
                    resolve(canvas.toDataURL());
                },
                useCORS: true
            });
        });
    },

    /**
     * 截图、下载图片
     * @method
     * @memberOf G.common.ScreenShot.prototype
     * @param [domId] {String} 截图的dom id
     * @param [name] {String} 下载的文件名
     * 
     */
    downloadImage(domId, name) {
        return new Promise(async(resolve, reject) => {
            let base64Str = await this.getImage(domId);
            name = name || 'screenshot';
            let fileName = name + '.png';
            //ie
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                let dataURItoBlob = function(dataURI) {
                    let binary = atob(dataURI.split(',')[1]);
                    let array = [];
                    for (let i = 0; i < binary.length; i++) {
                        array.push(binary.charCodeAt(i));
                    }
                    return new Blob([new Uint8Array(array)], { type: 'image/png' });
                }

                let blob = dataURItoBlob(base64Str);
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                let aLink = document.createElement('a');
                let parts = base64Str.split(';base64,');
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                let blob = new Blob([uInt8Array], { type: contentType }); //new Blob([content]);
                let evt = document.createEvent("HTMLEvents");
                evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
                aLink.download = fileName;
                aLink.href = URL.createObjectURL(blob);
                aLink.click()
            }
            resolve();
        });
    },

    /**
     * @inheritDoc
     */
    destroy() {
        //
        ComponentBase.prototype.destroy.call(this);
    }
});
module.exports = component;